import PageHeader from "src/components/PageHeader";

export default function Tags() {
  return (
    <PageHeader
      title="مدیریت برچسب محصولات"
    />
  )
}